module.exports = __webpack_public_path__ + "static/media/NoThreat.8403ed69.svg";